const CalendarIcon = () => {
  return (
    <svg viewBox="0 0 19.717 19.717">
      <g transform="translate(-63.156 -63.156)">
        <path
          d="M81.081,63.156H64.949a1.792,1.792,0,0,0-1.793,1.793V81.081a1.791,1.791,0,0,0,1.793,1.792H81.081a1.791,1.791,0,0,0,1.792-1.792V64.949A1.791,1.791,0,0,0,81.081,63.156ZM65.845,80.184a.9.9,0,1,1,.9-.9A.9.9,0,0,1,65.845,80.184Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,65.845,76.6Zm3.585,3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,69.43,80.184Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,69.43,76.6Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,69.43,73.015Zm3.585,7.169a.9.9,0,1,1,.9-.9A.9.9,0,0,1,73.015,80.184Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,73.015,76.6Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,73.015,73.015ZM76.6,80.184a.9.9,0,1,1,.9-.9A.9.9,0,0,1,76.6,80.184Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,76.6,76.6Zm-.9-4.481a.9.9,0,1,1,.9.9A.9.9,0,0,1,75.7,72.118ZM80.184,76.6a.9.9,0,1,1,.9-.9A.9.9,0,0,1,80.184,76.6Zm0-3.585a.9.9,0,1,1,.9-.9A.9.9,0,0,1,80.184,73.015Zm.9-4.481H64.949V64.949H81.081Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default CalendarIcon;
